import * as React from 'react'

import { LoyaltyBanner } from '../LoyaltyBanner'
import { PromoCodeBanner } from '../PromoCodeBanner'

import { PROMO_BANNER_TYPES, PromoBanner } from '../@types'

export type TypeAwareBannerProps = {
  banner: PromoBanner
  testId: string
}

export const TypeAwareBanner = ({ banner, testId }: TypeAwareBannerProps) => {
  switch (banner.__typename) {
    case PROMO_BANNER_TYPES.LoyaltyBanner:
      return <LoyaltyBanner banner={banner} testId={testId} />
    case PROMO_BANNER_TYPES.PromoCodeBanner:
    default:
      return <PromoCodeBanner banner={banner} testId={testId} />
  }
}
